import { html, unsafeHTML } from '@resn/gozer-core';

import { Component, componentMixin } from '@resn/gozer-core/component';
import DomComponentMixin from '@resn/gozer-core-mixins/dom-component';
import SectionMixin from 'component/sections/base/section-mixin';
import SectionFallbackMixin from 'component/sections/base/section-fallback-mixin';
import gsap from 'gsap';

import Copy from '@resn/gozer-core/copy';
import Svg from 'component/svg';
import { deviceBenchmark } from 'utils/device-benchmark';
import { getRoute } from 'utils/get-pages';
import { COLORS } from 'core/constants';
import { map } from '@resn/gozer-math';
import { isMobile } from '@resn/gozer-env';

import BtnMain from 'component/btn-main';
import Scene from './scene';

import getStore from 'core/store';
const store = getStore();

import './index.scss';
import { navigate } from 'utils/router-utils';
import { easings } from '@resn/gozer-animation';
import { lerp } from '@resn/gozer-math';
import { PAGE_DATA } from 'data/page-data';
import { currentPromotion } from 'data/promotion-data'
import picture from 'utils/picture';
import env from 'core/env';



const template = ({ options }) => html`
    <section class="section  homeXS1Hero inverseColors">
        <div data-ui="imageWrap" class="homeXS1Hero__imageWrap imageWrap">
            ${picture({
                src: options.srcHero,
                fit: isMobile ? 'contain' : 'cover',
                position: isMobile ? 'top' : 'center',
                className: 'imageWrap__image',
            })}
        </div>
        <div data-ui="inner" class="homeXS1Hero__inner  grid  maxWidth">
            <div data-ui="intro" class="homeXS1Hero__intro"></div>

            <div data-ui="content" class="homeXS1Hero__content">
                <h1 data-ui="logo" class="homeXS1Hero__title">XS1 ${Svg('xs1-logo', 'homeXS1Hero__xp1Logo')}</h1>
                <div class="homeXS1Hero__divider"></div>
                <h2 data-ui="subtitle" class="homeXS1Hero__subtitle  text-heading6">
                    ${ unsafeHTML(currentPromotion.homeBodyText)}
                </h2>

                <div data-ui="btnWrap" class="homeXS1Hero__btnWrap"></div>

                <div class="homeXS1Hero__conditions text-body3">
                    ${ unsafeHTML(Copy.get('home-ui-alaska-hawaii-banner')) }
                </div>
            </div>
        </div>
    </section>
`;
               
@componentMixin(DomComponentMixin)
@componentMixin(deviceBenchmark.fallback ? SectionFallbackMixin : SectionMixin)
class HomeXS1Hero extends Component {
    props = {
        animate: false,
        intro: false,
    };

    options = {
        template,

        srcHero: {
            desktop: `${env.CDN}static/images/pages/home/hero-xs1.jpg`,
            mobile: `${env.CDN}static/images/pages/home/hero-xs1-mobile.jpg`,
            // desktop: `${env.CDN}static/images/pages/home/xs1-hero/homepage-header_strengthtraining.jpg`,
            // mobile: `${env.CDN}static/images/pages/home/xs1-hero/homepage-header-mobile_strengthtraining.jpg`,
        },
    };

    async onSetup() {
        this.elements = [];

        this.btnExperience = await new BtnMain().setup({
            options: {
                appendTo: this.ui.btnWrap,
                className: 'exploreShrinkBtn',
                rolloverGradient: [COLORS.LIGHT_BLUE_2, COLORS.ORANGE],
                onClick: () => {
                    navigate(getRoute('xs1'));
                },
            },
            props: {
                text: Copy.get('home-xs1-hero-explore-button'),
                textColor: 'white',
                bgColor: COLORS.DARK_BLUE,
            },
        });

        this.btn = await new BtnMain().setup({
            options: {
                appendTo: this.ui.btnWrap,
                className: 'configureShrinkBtn',
                rolloverGradient: [COLORS.LIGHT_BLUE_2, COLORS.ORANGE],
                onClick: () => {
                    navigate(PAGE_DATA.CONFIGURE.XS1);
                },
            },
            props: {
                text: Copy.get('home-xs1-hero-configure-button'),
                textColor: 'white',
                bgColor: COLORS.LIGHT_BLUE,
            },
        });

        this.btnDemo = await new BtnMain().setup({
            options: {
                appendTo: this.ui.btnWrap,
                className: 'demoShrinkBtn',
                rolloverGradient: [COLORS.LIGHT_BLUE_2, COLORS.ORANGE],
                onClick: () => {
                    // window.open for desktops, window.location for mobile.
                    window.open(PAGE_DATA.SCHEDULE_DEMO.XS1, '_blank') || window.location.assign(PAGE_DATA.SCHEDULE_DEMO.XS1);
                },
            },
            props: {
                text: Copy.get('home-xs1-hero-demo-button'),
                textColor: 'white',
                bgColor: COLORS.DARK_BLUE,
            },
        });

        this.elements.push(
            this.ui.imageWrap,
            this.ui.btnWrap,
            this.ui.body,
            this.ui.subtitle,
            this.ui.logo,
            this.ui.pretitle,
        );

        // if (!deviceBenchmark.fallback) await this.setupScene();

        // this.setupIntro();
        this.initStyles();
    }

    initStyles() {
        if (this.introElements) gsap.set(this.introElements, { alpha: 0, willChange: 'transform' });
        gsap.set(this.elements, { alpha: 0, willChange: 'transform' });
        // gsap.set(this.ui.imageWrap, { alpha: 1 });
    }

    async setupScene() {
        this.scene = await new Scene().setup({
            options: {
                ui: this.ui,
                bgColor: COLORS.BLUE,
                useRendererBatch: isMobile,
            },
            props: {
                t: () => this.props.t,
                pX: () => this.props.x,
                scrollProgress: () => this.props.scrollProgress,
                scroll: () => this.props.scroll,

                translation: [150, -20],
                height: 1300,

                bounds: () => this.props.bounds,
                viewport: () => this.props.viewport,
                scale: () => this.props.scale,
                mobile: () => this.props.mobile,

                active: false,
                loaded: () => this.props.loaded,
            },
        });
    }

    onActive() {
        // this.props.animate = true;
        this.props.intro = true;
    }

    offActive() {
        if (this.showDelay) this.showDelay.kill();
    }

    onIntro() {
        if (this.ui.intro) gsap.set(this.ui.intro, { alpha: 0 });
        this.props.animate = true;
    }

    onAnimate() {
        const { mobile, scale, route } = store.state;

        if (this.scene) this.scene.props.active = true;

        if (route.first) {
            const yFrom = (mobile ? -100 : 80) * scale;
            const delay = mobile ? 0.23 : 0.1;
            const imgDur = mobile ? 0.3 : 0.4;
            const elDur = mobile ? 2 : 3;

            gsap.to(this.elements, { alpha: 1, duration: 1, delay, stagger: 0.06 });
            gsap.killTweensOf(this.ui.imageWrap);
            gsap.to(this.ui.imageWrap, { alpha: 1, duration: imgDur, delay, ease: 'sine.in' });
            gsap.fromTo(this.elements, { y: yFrom }, { y: 0, duration: elDur, delay, stagger: 0.06, ease: 'expo.out' });
        } else {
            gsap.set(this.ui.imageWrap, { alpha: 1 });
            gsap.set(this.elements, { alpha: 1, y: 0 });
        }
    }

    update() {
        const { mobile, scale } = store.state;
        const { scroll, bounds, viewport } = this.props;

        if (this.scene) {
            this.scene.props.pYOffset = this.y;
            this.scene.update();
        }

        if (mobile || deviceBenchmark.fallba) return;

        const yDist = 1200 * scale;
        const yPr = map(
            scroll,
            bounds.top - viewport.height - 1000 * scale,
            bounds.top - viewport.height + bounds.height,
            0,
            1,
            true,
        );

        const y = lerp(easings.easeOutSine(yPr), -yDist, 0);

        this.ui.inner.style.transform = `translateY(${y}px)`;
    }

    render() {
        if (this.scene) this.scene.render();
    }

    onDestroy() {
        if (this.showDelay) this.showDelay.kill();
        if (this.introTl) this.introTl.kill();
    }
}

export default HomeXS1Hero;
